exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FlashBox-module__flits-box___aRDJa{grid-column:1;grid-row:1;text-align:center;display:flex;justify-content:center;align-items:center;background-color:#fff;border-radius:10px;font-size:75px;font-weight:500;box-shadow:0 0 3px 0 rgba(0,0,0,.1);min-width:600px;min-height:200px}", ""]);

// exports
exports.locals = {
	"flits-box": "FlashBox-module__flits-box___aRDJa"
};